export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `<p>Форма - овал.<br>Размер - 9.8х7см.<br>Материал - виниловая плёнка (ПВХ), магнитная основа с полимерным покрытием «смола» (для объёмных стикеров).<br>Количество - 8 наклеек на лист А4.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p><span style='font-style: italic'>Виниловые наклейки</span> - полноцветное изображение наносится на самоклеющуюся плёнку ПВХ. В результате можно получить высококачественные наклейки фотографического качества.</p>
        <p><span style='font-style: italic'>Объёмные наклейки залитые смолой</span> - изображение наносится на магнитную основу. Сверху на изображение наносится специальное полимерное покрытие - «смола». Создаётся прозрачный и мягкий «купол». На завершающем этапе заготовки подвергаются термической обработке. В специальной камере смола затвердевает, а наклейка приобретает необходимый блеск.</p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
